import React, { useContext } from 'react'
import '../../../../../Portfolio_R/SummaryCharts/styles.scss'
import { useTranslation } from 'react-i18next'
import { useNumberFormatter } from '../../../../../../hooks/useNumberFormatter'
import HeaderExtended from '../../HeaderExtended'
import usePortfolioName from '../../../../../../hooks/usePortfolioName'
import { TagFilterContext } from '../../../../../../context/TagFilterContext'
import { IgrReportData } from '../typesExtendedReport'
import { useIgrMappedData } from './useIgrMappedData'
import ApprovedAmountsCard from './components/ApprovedAmountsCard'
import CompositionWalletCard from '../../../../../Portfolio_R/SummaryCharts/components/CompositionWalletCard';
import DisbursementsProjectionsYearCard from './components/DisbursementsProjectionsYearCard'
import PmrProjectsCard from './components/PmrProjectsCard'
import PendingCard from '../shared/PendingCard'
import TitlesAndValuesCard from '../shared/TitlesAndValuesCard'
import ReusableIcon from '../../shared/ReusableIcon'
import { ExpiredDisbursementsCard } from '../shared/ExpiredDisbursementsCard'

export const gradientColors = ['#0b396e', '#3975c8', '#4fa0a5', '#f39f2e', '#ffd700'];

interface IgrProps {
    data: IgrReportData | null | undefined;
    creationDate: string | Date;
    regions: any;
    countries?: string;
    myPortfolio?: string;
    filtersApplied?: any;
    isPdfExport?: boolean;
}


const ExtendedReportIgr: React.FC<IgrProps> = ({ data, creationDate, regions, countries, myPortfolio, filtersApplied, isPdfExport = false }) => {
    const { t } = useTranslation();
    const { formatMillions } = useNumberFormatter();
    const portfolioName = usePortfolioName();
    const { labels } = useContext(TagFilterContext);
    const title = 'IGR'
    const mp = useIgrMappedData(data, gradientColors);
    if (!data || !mp) return null;

    const compositionData = [
        {
            title: t('one_pager_report.projects'),
            data: mp.fields.projectTotalCount
        },
        {
            title: t('one_pager_report.operations'),
            data: mp.fields.operationTotalCount
        },
        {
            title: t('one_pager_report.years'),
            data: mp.fields.averageAge,
            units: (mp.fields.averageAge) > 1
                ? t('one_pager_report.antiquity_years')
                : t('one_pager_report.antiquity_year')
        }
    ]

    const approvedProjectsData = [
        {
            title: `${mp.approved.aprprovedProjectCount} ${t('one_pager_report.number_approved_projects')}`,
            data: formatMillions(mp.approved.aprprovedProjectAmount),
            units: "MM"
        },
        {
            title: `${mp.approved.preparationProjectCount} ${t('one_pager_report.projects_in_preparation')} (Pipeline A)`,
            data: formatMillions(mp.approved.preparationProjectAmount),
            units: "MM"
        }
    ]

    return (
        <>
            <div className='c-main'>
                <div style={{ margin: '0rem 1.5rem' }}>
                    <HeaderExtended
                        portfolioName={portfolioName}
                        filtersApplied={filtersApplied ?? labels}
                        creationDate={creationDate}
                        regions={regions}
                        countries={countries}
                        myPortfolio={myPortfolio}
                    />
                </div>

                <div className='content'>
                    <div className="section content-background">
                        <header className="header-content mb-2">
                            <p>{t('one_pager_report.igr_title')}</p>
                            <ReusableIcon
                                title={title}
                                color="#F1AF43"
                            />
                        </header>

                        <div className="c-charts-igr">
                            <TitlesAndValuesCard
                                principalTitle={t('one_pager_report.composition')}
                                generalData={compositionData}
                                styleContent="composition"
                            />

                            <ApprovedAmountsCard
                                mp={mp}
                                t={t}
                                formatMillions={formatMillions}
                            />

                            <TitlesAndValuesCard
                                principalTitle={t('one_pager_report.approved_proyects')}
                                generalData={approvedProjectsData}
                                styleContent='approve-projects'
                            />

                            <PendingCard
                                firstData={data.pendingLegalValidity}
                                firstTitle={t('one_pager_report.pending_legal_validity')}
                            />

                            <ExpiredDisbursementsCard quantity={data.projectsOverdueDisbursement} />

                            <CompositionWalletCard
                                sectors={mp.sectors}
                                dataSize={mp.dataSize}
                                colors={mp.colors(mp.dataSize)}
                                isPdfExport={isPdfExport}
                            />

                            <DisbursementsProjectionsYearCard
                                t={t}
                                mp={mp}
                            />

                            <PmrProjectsCard
                                mp={mp}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ExtendedReportIgr